/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

angular.module('prism-ui.components').service('ReportViewService',
    function ($interval, $q, PartnerResourceFactory, WorkflowExecutionResourceFactory, NotificationService, WorkflowService,
              PermissionsService, EndPointService, AuthFactory) {
        var self = this, executionPollIntervals = {},
            REPORT_WORKFLOW_KEY = 'generateReport';

        self.PARTNER_DELIVERY_REPORT_CLASS = 'BasicDeliveryReport';
        self.ADVANCED_PARTNER_DELIVERY_REPORT_CLASS = 'DeliveryReport';
        self.SLA_DELIVERY_REPORT_CLASS = 'SLADeliveryReport';
        self.DISTRIBUTION_REPORT_CLASS = 'BasicDistributionReport';
        self.ADVANCED_DISTRIBUTION_REPORT_CLASS = 'DistributionReport';
        self.PARTNER_PROFILES_REPORT_CLASS = 'VideoProfileReport';
        self.HIERARCHICAL_NETWORK_REPORT_CLASS = 'NetworkReport';
        self.HIERARCHICAL_SHOW_REPORT_CLASS = 'ShowReport';
        self.HIERARCHICAL_SEASON_VOLUME_REPORT_CLASS = 'SeasonVolumeReport';
        self.COLLABORATOR_REPORT_CLASS = 'CollaboratorReport';
        self.PACKAGE_BATCH_MODIFY_REPORT_CLASS = 'PackageMetadataBatchUpdateReport';
        self.PACKAGE_REPORT_CLASS = 'PackageReport';
        self.PACKAGE_ALL_METADATA_REPORT_CLASS = 'PackageMetadataReport';
        self.PACKAGE_MEDIA_REPORT_CLASS = 'PackageMediaReport';
        self.PARTNER_PLANNER_DELIVERY_REPORT_CLASS = 'PartnerPlannerReport';
        self.AUDIT_LEVEL_REPORT_CLASS = 'PartnerDeliveryReport';

        self.availableReports = [
            {
                label: 'Partner Delivery Report',
                showIncludePackagesOptions: true,
                generatorName: self.PARTNER_DELIVERY_REPORT_CLASS,
                advancedGeneratorName: self.ADVANCED_PARTNER_DELIVERY_REPORT_CLASS,
                viewState: 'DASHBOARD_REPORT_VIEW_STATE',
                path: '/dashboard/report/partnerdeliveryreport',
                reportClass: 'Package',
                modalTitle: 'Create Package Delivery Report',
                formTitle: 'Create a Basic or Advanced Package Delivery Report',
                includePartners: true
            },
            {
                label: 'SLA Delivery Metrics',
                showIncludePackagesOptions: true,
                generatorName: self.SLA_DELIVERY_REPORT_CLASS,
                viewState: 'DASHBOARD_REPORT_VIEW_STATE',
                path: '/dashboard/report/estdeliverymetrics',
                reportClass: 'PartnerPackageLog',
                modalTitle: 'Generate SLA Delivery Metrics',
                formTitle: 'Create an SLA Partner Delivery Metrics Report',
                includePartners: true
            },
            {
                label: 'Partner Delivery Report with Distribution Metadata',
                showIncludePackagesOptions: true,
                generatorName: self.AUDIT_LEVEL_REPORT_CLASS,
                viewState: 'DASHBOARD_REPORT_VIEW_STATE',
                path: '/dashboard/report/auditlevelreport',
                modalTitle: 'Create Partner Delivery Report with Distribution Metadata',
                formTitle: 'Create a Partner Delivery Report with Distribution Metadata',
                includePartners: true
            },
            {
                label: 'Distribution Report',
                generatorName: self.DISTRIBUTION_REPORT_CLASS,
                advancedGeneratorName: self.ADVANCED_DISTRIBUTION_REPORT_CLASS,
                viewState: 'DASHBOARD_REPORT_VIEW_STATE',
                path: '/dashboard/report/distributionreport',
                reportClass: 'Partner',
                modalTitle: 'Create Distribution Report',
                formTitle: 'Create a Package Distribution Report',
                includePartners: true
            },
            {
                label: 'Partner Profiles Report',
                generatorName: self.PARTNER_PROFILES_REPORT_CLASS,
                viewState: 'DASHBOARD_REPORT_VIEW_STATE',
                path: '/dashboard/report/partnerprofilesreport',
                reportClass: 'PartnerDeliveryProfile',
                modalTitle: 'Create Profiles Report',
                formTitle: 'Create a Partner Profiles Report',
                includePartners: true
            },
            {
                label: 'Partner Planners Delivery Report',
                generatorName: self.PARTNER_PLANNER_DELIVERY_REPORT_CLASS,
                viewState: 'DASHBOARD_REPORT_VIEW_STATE',
                path: '/dashboard/report/partnerplannerreport',
                reportClass: 'Partner',
                modalTitle: 'Create Partner Planner Delivery Report',
                formTitle: 'Create a Partner Planner Delivery Report',
                includePartners: true
            },
            {
                label: 'Hierarchical Metadata - Networks',
                generatorName: self.HIERARCHICAL_NETWORK_REPORT_CLASS,
                viewState: 'DASHBOARD_REPORT_VIEW_STATE',
                path: '/dashboard/report/networksmetadatareport',
                reportClass: 'AbstractShow',
                modalTitle: 'Create Networks Hierarchical Meta Report',
                formTitle: 'Create a Networks Hierarchical Metadata Report'
            },
            {
                label: 'Hierarchical Metadata - Series & Movie/Specials',
                generatorName: self.HIERARCHICAL_SHOW_REPORT_CLASS,
                viewState: 'DASHBOARD_REPORT_VIEW_STATE',
                path: '/dashboard/report/seriesmoviemetadatareport',
                reportClass: 'AbstractShow',
                modalTitle: 'Create Series/Movie Hierarchical Meta Report',
                formTitle: 'Create a Series/Movie Hierarchical Metadata Report'
            },
            {
                label: 'Hierarchical Metadata - Series Seasons & Volumes',
                generatorName: self.HIERARCHICAL_SEASON_VOLUME_REPORT_CLASS,
                viewState: 'DASHBOARD_REPORT_VIEW_STATE',
                path: '/dashboard/report/seasonvolumemetadatareport',
                reportClass: 'Series',
                modalTitle: 'Create Season/Volume Hierarchical Meta Report',
                formTitle: 'Create a Season/Volume Hierarchical Metadata Report'
            },
            {
                label: 'Collaborators Report',
                generatorName: self.COLLABORATOR_REPORT_CLASS,
                viewState: 'DASHBOARD_REPORT_VIEW_STATE',
                path: '/dashboard/report/collaboratorsreport',
                reportClass: 'Collaborator',
                modalTitle: 'Create Collaborators Report',
                formTitle: 'Create a Collaborators Report'
            }
        ];

        self.PACKAGE_BATCH_MODIFY_REPORT = {
            label: 'Package Metadata Report',
            generatorName: self.PACKAGE_BATCH_MODIFY_REPORT_CLASS,
            reportClass: 'Package',
            modalTitle: 'Batch Modify Warning'
        };

        self.PACKAGE_REPORT = {
            label: 'Package Report',
            showIncludePackagesOptions: true,
            generatorName: self.PACKAGE_REPORT_CLASS,
            reportClass: 'Package',
            modalTitle: 'Export Package Data',
            formTitle: 'Create a package report for the current packages'
        };

        self.PACKAGE_ALL_METADATA_REPORT = {
            label: 'Package Metadata Report',
            showIncludePackagesOptions: true,
            generatorName: self.PACKAGE_ALL_METADATA_REPORT_CLASS,
            reportClass: 'Package',
            modalTitle: 'Export Package Metadata',
            formTitle: 'Create a metadata report for the current packages'
        };

        self.CLIP_PACKAGE_ALL_METADATA_REPORT = {
            label: 'Package Metadata Report',
            generatorName: self.PACKAGE_ALL_METADATA_REPORT_CLASS,
            viewState: 'CLIP_ACTION_EXPORT_METADATA_VIEW_STATE',
            reportClass: 'Package',
            modalTitle: 'Export Package Metadata',
            formTitle: 'Create a metadata report for the current packages'
        };

        self.PACKAGE_MEDIA_REPORT = {
            label: 'Media Report',
            showIncludePackagesOptions: true,
            generatorName: self.PACKAGE_MEDIA_REPORT_CLASS,
            reportClass: 'Package',
            modalTitle: 'Create Package Media Report',
            formTitle: 'Create a Media Report'
        };

        self.CLIP_PACKAGE_DELIVERY_REPORT = {
            label: 'Partner Delivery Report',
            generatorName: self.PARTNER_DELIVERY_REPORT_CLASS,
            advancedGeneratorName: self.ADVANCED_PARTNER_DELIVERY_REPORT_CLASS,
            viewState: 'CLIP_ACTION_GENERATE_DELIVERY_REPORT_VIEW_STATE',
            path: '/dashboard/report/partnerdeliveryreport',
            reportClass: 'Package',
            modalTitle: 'Create Package Delivery Report',
            formTitle: 'Create a Basic or Advanced Package Delivery Report',
            includePartners: true
        };

        self.PACKAGE_AUDIT_LEVEL_REPORT = {
            label: 'Partner Delivery Report with Distribution Metadata',
            showIncludePackagesOptions: true,
            generatorName: self.AUDIT_LEVEL_REPORT_CLASS,
            viewState: 'DASHBOARD_REPORT_VIEW_STATE',
            path: '/dashboard/report/auditlevelreport',
            modalTitle: 'Create Partner Delivery Report with Distribution Metadata',
            formTitle: 'Create a Partner Delivery Report with Distribution Metadata',
            includePartners: true
        };

        var getReportCriteria = function (options) {
            var reportCriteria = {};
            if (options.reportStartDate) {
                reportCriteria.fromDate = options.reportStartDate;
            }
            if (options.reportEndDate) {
                reportCriteria.toDate = options.reportEndDate;
            }
            if (options.selectedPartners) {
                reportCriteria.targetObjectIds = options.selectedPartners.map(function (partner) {
                    return parseInt(partner.id);
                });
            } else if (options.selectedPackages) {
                reportCriteria.targetObjectIds = options.selectedPackages.map(function (pkg) {
                    return parseInt(pkg.id);
                });
                reportCriteria.targetObjectPath = 'package.id';

            }
            if (options.includeArchiveContent !== null) {
                reportCriteria.includeArchived = options.includeArchiveContent;
            }
            if (options.includeMasterPkgs !== null) {
                reportCriteria.includeMasterPackages = options.includeMasterPkgs;
            }
            if (options.includeClipToolPkgs !== null) {
                reportCriteria.includeClipPackages = options.includeClipToolPkgs;
            }
            if (options.filterCriteria) {
                reportCriteria.filterCriteria = options.filterCriteria;
            }
            return reportCriteria;
        };

        var generateWorkflowBody = function (selectedReport, options) {
            return {
                reportName: options.name,
                reportGeneratorName: (options.mode === 'Advanced') ? selectedReport.advancedGeneratorName : selectedReport.generatorName,
                reportClassName: selectedReport.reportClass,
                reportFormat: 'XLSX',
                runAsCurrentUser: false,
                reportCriteria: getReportCriteria(options)
            };
        };

        var cleanupExecutionPollInterval = function (workflowGuid) {
            $interval.cancel(executionPollIntervals[workflowGuid]);
            delete executionPollIntervals[workflowGuid];
        };

        var pollForWorkflowExecution = function (reportName, workflowGuid) {
            WorkflowExecutionResourceFactory.getWorkflowExecution({id: workflowGuid}).$promise.then(function (workflowExecution) {
                if (parseInt(workflowExecution.percentComplete) === 100 && workflowExecution.isDownloadAvailable) {
                    cleanupExecutionPollInterval(workflowGuid);
                    NotificationService.createInfoNotification('Report Generation Complete:\n' + reportName, 'Download Report', function () {
                        window.open(EndPointService.workflowFilesEndpoint + '/' + workflowExecution.id +
                            '?attach=true&' + AuthFactory.getAuthQueryString());
                    });
                } else if (WorkflowService.hasWorkflowFailed(workflowExecution.status)) {
                    cleanupExecutionPollInterval(workflowGuid);
                    WorkflowExecutionResourceFactory.getExecutionSteps({id: workflowGuid}).$promise.then(function (steps) {
                        var errorText = steps[steps.length - 1].exceptionText;
                        NotificationService.createFailureNotification('Report Generation encountered an Error.', errorText, true);
                    });
                } else if (WorkflowService.hasWorkflowBeenAbandoned(workflowExecution.status)) {
                    cleanupExecutionPollInterval(workflowGuid);
                    NotificationService.createWarningNotification('Report Generation Abandoned:' + reportName);
                }
            });
        };

        self.getReportForPath = function (path) {
            return self.availableReports.filter(function (report) {
                return report.path === path;
            })[0];
        };

        self.queryForPartners = function (includeHidden) {
            self.partners = PartnerResourceFactory.query({fetchLimit: 1000, includeHidden: includeHidden});
            return self.partners.$promise;
        };

        self.startReportWorkflow = function (selectedReport, options) {
            let workflowParameters = generateWorkflowBody(selectedReport, options);
            return WorkflowService.startWorkflow(REPORT_WORKFLOW_KEY, workflowParameters)
                .then((workflowExecution) => {
                    NotificationService.createInfoNotification(
                        'Generating Report:\n' +
                        workflowParameters.reportName +
                        '\nYou will receive an email when this report is complete');
                    executionPollIntervals[workflowExecution.workflowGuid] = $interval(
                        pollForWorkflowExecution,
                        3000,
                        0,
                        true,
                        workflowParameters.reportName,
                        workflowExecution.workflowGuid);
                });
        };

        self.doesUserHaveWritePermission = function (selectedReport) {
            return PermissionsService.getPermissionsForViewState(selectedReport.viewState).then(function (viewState) {
                return $q.when(PermissionsService.hasWritePermission(viewState.permission));
            });
        };

    });
